import { ActivatedRoute, Params, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { BBWTMessageService } from '../../services/message.service';
import { ConfirmationService } from 'primeng';

import { SelectItem } from 'primeng';
import { DashboardSummaryService } from '../../services/dashboard-summary.service';

@Component({
  selector: 'dashboard-summary',
  templateUrl: './dashboard-summary.component.html',
  styles: [
    `
      body .ui-datatable.ui-datatable-scrollable thead tr th {
        font-size: 12px;
      }
      body .ui-widget-content {
        font-size: 12px;
      }
    `,
  ],
  providers: [DashboardSummaryService],
})
export class DashboardSummaryComponent implements OnInit {
  public accessDetail: any = null;
  public notFound: boolean = false;
  public isLoading: boolean = true;

  data: any[];
  pageObject: any;
  dataLoaded: boolean;
  data2: any[];
  selectedItems: any[];
  cols: any[];
  cities: SelectItem[];
  summaryDataList: SummaryData[];
  showSummaryView: boolean;
  showDetailView: boolean;
  chartData: any;
  JobCountOptions: any;
  AreaOptions: any;
  EarningsOptions: any;
  RatingOptions: any;
  RefusedJobOptions: any;
  PerformanceOptions: any;
  DataOptions: any;
  DistanceOptions: any;
  StatOptions: any;
  CustStatOptions: any;
  ABBAOptions: any;
  CustABBAOptions: any;
  supplierName: string;
  SelectDays: number = 0;
  strDays: string;
  radioSelected: string;

  JobCountData: any;
  AreaData: any;
  EarningsData: any;
  RatingData: any;
  RefusedJob: any;
  PerformanceData: any;
  ManagementData: any;
  DistanceData: any;
  StatData: any;
  CustStatData: any;
  ABBAData: any;
  CustABBAData: any;
  today: any = new Date();
  aMonth: number = this.today.getMonth();
  monthLabel: any[];
  months: any[] = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  //monthLabel: any[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  constructor(
    private route: ActivatedRoute,
    public messageService: BBWTMessageService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private dashboardSummaryService: DashboardSummaryService,
  ) {
    this.radioSelected = '0';
  }

  ngOnInit() {
    this.pageObject = {};
    this.data = [];
    this.data2 = [];
    this.selectedItems = [];
    this.monthLabel = [];
    this.dataLoaded = false;
    this.showSummaryView = true;
    this.showDetailView = false;
    //console.log(this.aMonth);
    //console.log("----------------------------------");
    for (let i = 0; i < 12; i++) {
      this.monthLabel.push(this.months[this.aMonth]);
      this.aMonth--;
      if (this.aMonth < 0) {
        this.aMonth = 11;
      }
      //console.log(this.aMonth);
    }
    this.monthLabel = this.monthLabel.reverse();
    //console.log("----------------------------------");
    //console.log(this.aMonth);
    //console.log(this.monthLabel);
    this.JobCountOptions = {
      scaleShowValues: true,
      responsive: false,
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      scales: {
        yAxes: [
          {
            type: 'linear',
            position: 'left',
            ticks: {
              beginAtZero: true,
              stepSize: 5,
              fontColor: '#0083c9',
            },
            gridLines: {
              color: 'rgba(0, 131, 201, 0.1)',
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              autoSkip: true,
            },
          },
        ],
      },
    };
    this.AreaOptions = {
      scaleShowValues: true,
      responsive: false,
      maintainAspectRatio: false,
      legend: {
        display: true,
      },
      scales: {
        yAxes: [
          {
            type: 'linear',
            position: 'left',
            ticks: {
              beginAtZero: true,
              stepSize: 5,
              fontColor: '#0083c9',
            },
            gridLines: {
              color: 'rgba(0, 131, 201, 0.1)',
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              autoSkip: true,
            },
          },
        ],
      },
    };
    this.EarningsOptions = {
      scaleShowValues: true,
      responsive: false,
      maintainAspectRatio: false,
      legend: {
        display: true,
      },
      scales: {
        yAxes: [
          {
            id: 'Earnings',
            type: 'linear',
            position: 'left',
            ticks: {
              beginAtZero: true,
              stepSize: 100,
              fontColor: '#0083c9',
            },
            gridLines: {
              color: 'rgba(0, 131, 201, 0.1)',
            },
            scaleLabel: {
              display: true,
              labelString: 'Earnings',
              fontColor: '#0083c9',
              fontFamily: 'Arial',
              fontStyle: 'normal',
              fontSize: 16,
              padding: 6,
              lineHeight: 2,
            },
          },
          {
            id: 'Average',
            type: 'linear',
            position: 'right',
            ticks: {
              autoSkip: true,
              beginAtZero: true,
              stepSize: 50,
              fontColor: '#cc0055',
            },
            gridLines: {
              color: 'rgba(204, 0, 85, 0.1)',
            },
            scaleLabel: {
              display: true,
              labelString: 'Average',
              fontColor: '#cc0055',
              fontFamily: 'Arial',
              fontStyle: 'normal',
              fontSize: 16,
              padding: 6,
              lineHeight: 2,
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              autoSkip: true,
            },
          },
        ],
      },
    };
    this.RatingOptions = {
      scaleShowValues: true,
      responsive: false,
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      scales: {
        yAxes: [
          {
            type: 'linear',
            position: 'left',
            ticks: {
              beginAtZero: true,
              stepSize: 1,
              max: 5,
              fontColor: '#0083c9',
            },
            gridLines: {
              color: 'rgba(0, 131, 201, 0.1)',
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              autoSkip: true,
            },
          },
        ],
      },
    };
    this.RefusedJobOptions = {
      scaleShowValues: true,
      responsive: false,
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      scales: {
        yAxes: [
          {
            type: 'linear',
            position: 'left',
            ticks: {
              beginAtZero: true,
              stepSize: 2,
              fontColor: '#cc0055',
            },
            gridLines: {
              color: 'rgba(204, 0, 85, 0.1)',
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              autoSkip: true,
            },
          },
        ],
      },
    };
    this.PerformanceOptions = {
      scaleShowValues: true,
      responsive: false,
      maintainAspectRatio: false,
      legend: {
        display: true,
      },
      scales: {
        yAxes: [
          {
            type: 'linear',
            position: 'left',
            ticks: {
              beginAtZero: true,
              stepSize: 500,
              fontColor: '#0083c9',
            },
            gridLines: {
              color: 'rgba(0, 131, 201, 0.1)',
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              autoSkip: true,
            },
          },
        ],
      },
    };
    this.DataOptions = {
      scaleShowValues: true,
      responsive: false,
      maintainAspectRatio: false,
      legend: {
        display: true,
      },
      scales: {
        yAxes: [
          {
            type: 'linear',
            position: 'left',
            ticks: {
              beginAtZero: true,
              stepSize: 5,
              fontColor: '#0083c9',
            },
            gridLines: {
              color: 'rgba(0, 131, 201, 0.1)',
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              autoSkip: true,
            },
          },
        ],
      },
    };
    this.DistanceOptions = {
      scaleShowValues: true,
      responsive: false,
      maintainAspectRatio: false,
      legend: {
        display: true,
      },
      scales: {
        yAxes: [
          {
            type: 'linear',
            position: 'left',
            ticks: {
              beginAtZero: true,
              stepSize: 50,
              fontColor: '#0083c9',
            },
            gridLines: {
              color: 'rgba(0, 131, 201, 0.1)',
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              autoSkip: true,
            },
          },
        ],
      },
    };
    this.StatOptions = {
      scaleShowValues: true,
      responsive: false,
      maintainAspectRatio: false,
      legend: {
        display: true,
      },
      scales: {
        yAxes: [
          {
            type: 'linear',
            position: 'left',
            ticks: {
              beginAtZero: true,
              stepSize: 5,
              fontColor: '#0083c9',
            },
            gridLines: {
              color: 'rgba(0, 131, 201, 0.1)',
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              autoSkip: true,
            },
          },
        ],
      },
    };
    this.CustStatOptions = {
      scaleShowValues: true,
      responsive: false,
      maintainAspectRatio: false,
      legend: {
        display: true,
      },
      scales: {
        xAxes: [
          {
            type: 'linear',
            position: 'left',
            ticks: {
              beginAtZero: true,
              stepSize: 5,
              fontColor: '#0083c9',
            },
            gridLines: {
              color: 'rgba(0, 131, 201, 0.1)',
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              autoSkip: true,
            },
          },
        ],
      },
    };
    this.ABBAOptions = {
      scaleShowValues: true,
      responsive: false,
      maintainAspectRatio: false,
      legend: {
        display: true,
      },
      scales: {
        yAxes: [
          {
            type: 'linear',
            position: 'left',
            ticks: {
              beginAtZero: true,
              stepSize: 5,
              fontColor: '#0083c9',
            },
            gridLines: {
              color: 'rgba(0, 131, 201, 0.1)',
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              autoSkip: true,
            },
          },
        ],
      },
    };
    this.CustABBAOptions = {
      scaleShowValues: true,
      responsive: false,
      maintainAspectRatio: false,
      legend: {
        display: true,
      },
      scales: {
        xAxes: [
          {
            type: 'linear',
            position: 'left',
            ticks: {
              beginAtZero: true,
              stepSize: 5,
              fontColor: '#0083c9',
            },
            gridLines: {
              color: 'rgba(0, 131, 201, 0.1)',
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              autoSkip: true,
            },
          },
        ],
      },
    };
    this.loadJobCount();
  }

  loadJobCount() {
    this.dashboardSummaryService
      .GetDBJobCount()
      .then((jobCounts) => {
        this.pageObject.jobCounts = jobCounts;
        this.formatData();
        this.loadArea();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  loadArea() {
    this.dashboardSummaryService
      .GetDBArea()
      .then((areaCounts) => {
        this.pageObject.areaCounts = areaCounts;
        this.formatData();
        this.loadEarnings();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  loadEarnings() {
    this.dashboardSummaryService
      .GetDBEarnings()
      .then((earningCounts) => {
        this.pageObject.earningCounts = earningCounts;
        this.formatData();
        this.loadStat();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  loadStat() {
    this.dashboardSummaryService
      .GetDBStats()
      .then((statCounts) => {
        this.pageObject.statCounts = statCounts;
        this.formatData();
        //this.loadData();
        this.loadRate();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  loadData() {
    this.dashboardSummaryService
      .getDBData()
      .then((dataCount) => {
        this.pageObject.dataCount = dataCount;
        this.formatData();
        this.loadRate();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  loadRate() {
    this.dashboardSummaryService
      .getDBRating()
      .then((rateCount) => {
        this.pageObject.rateCount = rateCount;
        this.formatData();
        this.loadABBA();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  loadABBA() {
    this.dashboardSummaryService
      .getDBABBA()
      .then((ABBACount) => {
        this.pageObject.ABBACount = ABBACount;
        this.formatData();
        this.loadDistance();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  loadDistance() {
    this.dashboardSummaryService
      .GetDBDistance()
      .then((distanceCounts) => {
        this.pageObject.distanceCounts = distanceCounts;
        this.formatData();
        this.loadRefusedJobs();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  loadRefusedJobs() {
    this.dashboardSummaryService
      .GetDBRefusedJobs()
      .then((refusedCounts) => {
        this.pageObject.refusedCounts = refusedCounts;
        this.formatData();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  formatData() {
    this.summaryDataList = [];
    const showIndex = this.SelectDays;
    if (this.SelectDays == 0) {
      this.strDays = 'For Last 90 Days';
    } else if (this.SelectDays == 1) {
      this.strDays = 'For Last 30 Days';
    } else if (this.SelectDays == 2) {
      this.strDays = 'For Last 7 Days';
    }
    for (var property in this.pageObject) {
      if (this.pageObject.hasOwnProperty(property)) {
        this.pageObject[property].forEach((item) => {
          let summaryItem: SummaryData = this.getSummaryItem(item.id);
          if (summaryItem === undefined || summaryItem === null) {
            summaryItem = new SummaryData();
            summaryItem.id = item.id;
            summaryItem.supplier = item.name;
            this.summaryDataList.push(summaryItem);
          }
          switch (property) {
            case 'jobCounts':
              summaryItem.jobCount = item.value[showIndex] != null ? item.value[showIndex] : 0;
              summaryItem.jobCountArray = item.value;
              break;
            case 'areaCounts':
              summaryItem.areaHome = item.count[showIndex] != null ? item.count[showIndex] : 0;
              summaryItem.areaOutside =
                summaryItem.jobCount - (item.count[showIndex] != null ? item.count[showIndex] : 0); //(item.count1[showIndex] != null) ? item.count1[showIndex] : 0;
              summaryItem.areaHomeArray = item.count;
              item.count1[0] =
                summaryItem.jobCountArray[0] - (item.count[0] != null ? item.count[0] : 0);
              item.count1[1] =
                summaryItem.jobCountArray[1] - (item.count[1] != null ? item.count[1] : 0);
              item.count1[2] =
                summaryItem.jobCountArray[2] - (item.count[2] != null ? item.count[2] : 0);
              summaryItem.areaOutsideArray = item.count1;
              break;
            case 'earningCounts':
              summaryItem.earnings =
                item.earnValue[showIndex] != null ? item.earnValue[showIndex].toFixed(2) : 0;
              summaryItem.earningsArray = item.earnValue;
              summaryItem.average =
                item.avgValue[showIndex] != null ? item.avgValue[showIndex].toFixed(2) : 0;
              summaryItem.averageArray = item.avgValue;
              break;
            case 'statCounts':
              summaryItem.statOntime = item.count[showIndex] != null ? item.count[showIndex] : 0;
              summaryItem.statDelay = item.count1[showIndex] != null ? item.count1[showIndex] : 0;
              summaryItem.statOntimeArray = item.count;
              summaryItem.statDelayArray = item.count1;
              break;
            case 'dataCount':
              summaryItem.wtwp = item.wtwp[showIndex] != null ? item.wtwp[showIndex] : 0;
              summaryItem.wtwpArray = item.wtwp;
              summaryItem.wtwop = item.wtwop[showIndex] != null ? item.wtwop[showIndex] : 0;
              summaryItem.wtwopArray = item.wtwop;
              summaryItem.wotwp = item.wotwp[showIndex] != null ? item.wotwp[showIndex] : 0;
              summaryItem.wotwpArray = item.wotwp;
              summaryItem.wotwop = item.wotwop[showIndex] != null ? item.wotwop[showIndex] : 0;
              summaryItem.wotwopArray = item.wotwop;
              break;
            case 'rateCount':
              summaryItem.rate = item.rate[showIndex] != null ? item.rate[showIndex] : 0;
              summaryItem.rateArray = item.rate;
              break;
            case 'ABBACount':
              summaryItem.Single = item.single[showIndex] != null ? item.single[showIndex] : 0;
              summaryItem.SingleArray = item.single;
              summaryItem.Multiple =
                item.multiple[showIndex] != null ? item.multiple[showIndex] : 0;
              summaryItem.MultipleArray = item.multiple;
              break;
            case 'distanceCounts':
              summaryItem.distanceMin =
                item.minValue[showIndex] != null ? item.minValue[showIndex] : 0;
              summaryItem.distanceMinArray = item.minValue;
              summaryItem.distanceMax =
                item.maxValue[showIndex] != null ? item.maxValue[showIndex] : 0;
              summaryItem.distanceMaxArray = item.maxValue;
              summaryItem.distanceAvg =
                item.avgValue[showIndex] != null ? item.avgValue[showIndex] : 0;
              summaryItem.distanceAvgArray = item.avgValue;
              break;
            case 'refusedCounts':
              summaryItem.refusedJobCount =
                item.value[showIndex] != null ? item.value[showIndex] : 0;
              summaryItem.refusedJobCountArray = item.value;
              break;
          }
          //console.log(item);
        });
        //console.log(property);
      }
    }
    //console.log(this.summaryDataList);
    this.dataLoaded = true;
  }

  rowClick(item) {
    this.showSummaryView = false;
    this.showDetailView = true;
    const rowData = item;
    rowData.selected = !rowData.selected;
    this.loadDetailBySupplierId(item);
    //console.log($event);
  }

  loadDetailBySupplierId(supplierObj: SummaryData) {
    this.supplierName = supplierObj.supplier;
    let jobcount = [];
    this.dashboardSummaryService.GetDBJobCountDet(supplierObj.id).then((jobDetail) => {
      5;
      for (let i = 0; i < 12; i++) {
        let value = 0;
        jobDetail.forEach((item) => {
          if (this.months[item.month - 1] == this.monthLabel[i]) {
            value = item.value;
          }
        });
        jobcount.push(value);
      }

      this.JobCountData = {
        labels: this.monthLabel,
        datasets: [
          {
            label: 'Job Count',
            data: jobcount,
            lineTension: 0,
            fill: false,
            borderColor: '#0083c9',
          },
        ],
      };
    });

    this.dashboardSummaryService.GetDBAreaDet(supplierObj.id).then((jobDetail) => {
      let homecnt = [];
      let outcnt = [];
      for (let i = 0; i < 12; i++) {
        let homeval = 0;
        let outval = 0;
        jobDetail.forEach((item) => {
          if (this.months[item.month - 1] == this.monthLabel[i]) {
            homeval = item.count;
          }
        });
        outval = jobcount[i] - homeval;
        if (outval < 0) {
          outval = 0;
        }
        homecnt.push(homeval);
        outcnt.push(outval);
      }

      this.AreaData = {
        labels: this.monthLabel,
        datasets: [
          {
            label: 'Home',
            data: homecnt,
            lineTension: 0,
            fill: false,
            borderColor: '#0083c9',
          },
          {
            label: 'Outside',
            data: outcnt,
            lineTension: 0,
            fill: false,
            borderColor: '#cc0055',
          },
        ],
      };
    });

    this.dashboardSummaryService.GetDBEarningsDet(supplierObj.id).then((jobDetail) => {
      let earn = [];
      let avg = [];
      for (let i = 0; i < 12; i++) {
        let earnvalue = 0;
        let avgvalue = 0;
        jobDetail.forEach((item) => {
          if (this.months[item.month - 1] == this.monthLabel[i]) {
            earnvalue = item.earnValue;
            avgvalue = item.avgValue;
          }
        });
        earn.push(earnvalue);
        avg.push(avgvalue);
      }

      this.EarningsData = {
        labels: this.monthLabel,
        datasets: [
          {
            label: 'Earnings',
            type: 'line',
            borderColor: '#0083c9',
            yAxisID: 'Earnings',
            lineTension: 0,
            fill: false,
            data: earn,
          },
          {
            label: 'Average',
            backgroundColor: '#cc0055',
            borderColor: '#cc0055',
            yAxisID: 'Average',
            lineTension: 0,
            fill: false,
            data: avg,
          },
        ],
      };
    });

    this.dashboardSummaryService.GetDBRefusedJobsDet(supplierObj.id).then((jobDetail) => {
      let data = [];
      for (let i = 0; i < 12; i++) {
        let value = 0;
        jobDetail.forEach((item) => {
          if (this.months[item.month - 1] == this.monthLabel[i]) {
            value = item.value;
          }
        });
        data.push(value);
      }

      this.RefusedJob = {
        labels: this.monthLabel,
        datasets: [
          {
            label: 'Refused Jobs',
            data: data,
            lineTension: 0,
            fill: false,
            borderColor: '#cc0055',
          },
        ],
      };
      //console.log(this.RefusedJob);
    });

    this.dashboardSummaryService.getDBRatingDet(supplierObj.id).then((jobDetail) => {
      let data = [];
      for (let i = 0; i < 12; i++) {
        let value = 0;
        jobDetail.forEach((item) => {
          if (this.months[item.month - 1] == this.monthLabel[i]) {
            value = item.rate;
          }
        });
        data.push(value);
      }

      this.RatingData = {
        labels: this.monthLabel,
        datasets: [
          {
            label: 'Driver Rating',
            data: data,
            lineTension: 0,
            fill: false,
            borderColor: '#0083c9',
          },
        ],
      };
    });

    this.dashboardSummaryService.getDBDataDet(supplierObj.id).then((jobDetail) => {
      let wtwpcnt = [];
      let wtwopcnt = [];
      let wotwpcnt = [];
      let wotwopcnt = [];
      for (let i = 0; i < 12; i++) {
        let wtwpval = 0;
        let wtwopval = 0;
        let wotwpval = 0;
        let wotwopval = 0;
        jobDetail.forEach((item) => {
          //console.log(item);
          if (this.months[item.month - 1] == this.monthLabel[i]) {
            wtwpval = item.wtwp;
            wtwopval = item.wtwop;
            wotwpval = item.wotwp;
            wotwopval = item.wotwop;
          }
        });
        wtwpcnt.push(wtwpval);
        wtwopcnt.push(wtwopval);
        wotwpcnt.push(wotwpval);
        wotwopcnt.push(wotwopval);
      }

      this.ManagementData = {
        labels: this.monthLabel,
        datasets: [
          {
            label: 'WTWP',
            data: wtwpcnt,
            lineTension: 0,
            fill: false,
            borderColor: '#022369',
            backgroundColor: '#022369',
          },
          {
            label: 'WTWOP',
            data: wtwopcnt,
            lineTension: 0,
            fill: false,
            borderColor: '#c7820a',
            backgroundColor: '#c7820a',
          },
          {
            label: 'WOTWP',
            data: wotwpcnt,
            lineTension: 0,
            fill: false,
            borderColor: '#0083c9',
            backgroundColor: '#0083c9',
          },
          {
            label: 'WOTWOP',
            data: wotwopcnt,
            lineTension: 0,
            fill: false,
            borderColor: '#cc0055',
            backgroundColor: '#cc0055',
          },
        ],
      };
      //console.log(this.ManagementData);
    });

    this.dashboardSummaryService.getDBPerformanceDet(supplierObj.id).then((jobDetail) => {
      let actcnt = [];
      let estcnt = [];
      for (let i = 0; i < 12; i++) {
        let actval = 0;
        let estval = 0;
        jobDetail.forEach((item) => {
          if (this.months[item.month - 1] == this.monthLabel[i]) {
            actval = item.actualValue;
            estval = item.estValue;
          }
        });
        actcnt.push(actval);
        estcnt.push(estval);
      }

      this.PerformanceData = {
        labels: this.monthLabel,
        datasets: [
          {
            label: 'Actual',
            data: actcnt,
            lineTension: 0,
            fill: false,
            borderColor: '#0083c9',
            backgroundColor: '#0083c9',
          },
          {
            label: 'Estimate',
            data: estcnt,
            lineTension: 0,
            fill: false,
            borderColor: '#c7820a',
            backgroundColor: '#c7820a',
          },
        ],
      };
    });

    this.dashboardSummaryService.GetDBDistanceDet(supplierObj.id).then((jobDetail) => {
      let mincnt = [];
      let maxcnt = [];
      let avgcnt = [];
      for (let i = 0; i < 12; i++) {
        let minval = 0;
        let maxval = 0;
        let avgval = 0;
        jobDetail.forEach((item) => {
          if (this.months[item.month - 1] == this.monthLabel[i]) {
            minval = item.minValue;
            maxval = item.maxValue;
            avgval = item.avgValue;
          }
        });
        mincnt.push(minval);
        maxcnt.push(maxval);
        avgcnt.push(avgval);
      }

      this.DistanceData = {
        labels: this.monthLabel,
        datasets: [
          {
            label: 'Minimum',
            data: mincnt,
            lineTension: 0,
            fill: false,
            borderColor: '#022369',
            backgroundColor: '#022369',
          },
          {
            label: 'Maximum',
            data: maxcnt,
            lineTension: 0,
            fill: false,
            borderColor: '#c7820a',
            backgroundColor: '#c7820a',
          },
          {
            label: 'Average',
            data: avgcnt,
            lineTension: 0,
            fill: false,
            borderColor: '#0083c9',
            backgroundColor: '#0083c9',
          },
        ],
      };
    });

    this.dashboardSummaryService.GetDBStatsDet(supplierObj.id).then((jobDetail) => {
      let ontimecnt = [];
      let delaycnt = [];
      for (let i = 0; i < 12; i++) {
        let ontimeval = 0;
        let delayval = 0;
        jobDetail.forEach((item) => {
          //console.log(item);
          if (this.months[item.month - 1] == this.monthLabel[i]) {
            ontimeval = item.count1;
            delayval = item.count2;
          }
        });
        ontimecnt.push(ontimeval);
        delaycnt.push(delayval);
      }
      this.StatData = {
        labels: this.monthLabel,
        datasets: [
          {
            label: 'OnTime',
            data: ontimecnt,
            lineTension: 0,
            fill: false,
            borderColor: '#0083c9',
            backgroundColor: '#0083c9',
          },
          {
            label: 'Delay',
            data: delaycnt,
            lineTension: 0,
            fill: false,
            borderColor: '#cc0055',
            backgroundColor: '#cc0055',
          },
        ],
      };
    });

    this.dashboardSummaryService.GetDBStatsCust(supplierObj.id).then((jobDetail) => {
      let ontimecnt = [];
      let delaycnt = [];
      let custname = [];
      let i = 1;
      jobDetail.forEach((item) => {
        custname.push(item.name);
        //custname.push("Cust" + i);
        ontimecnt.push(item.count1);
        delaycnt.push(item.count2);
        i = i + 1;
      });
      this.CustStatData = {
        labels: custname,
        datasets: [
          {
            label: 'OnTime',
            data: ontimecnt,
            lineTension: 0,
            fill: false,
            borderColor: '#0083c9',
            backgroundColor: '#0083c9',
          },
          {
            label: 'Delay',
            data: delaycnt,
            lineTension: 0,
            fill: false,
            borderColor: '#cc0055',
            backgroundColor: '#cc0055',
          },
        ],
      };
    });

    this.dashboardSummaryService.getDBABBADet(supplierObj.id).then((jobDetail) => {
      let singlecnt = [];
      let multicnt = [];
      for (let i = 0; i < 12; i++) {
        let singleval = 0;
        let multival = 0;
        jobDetail.forEach((item) => {
          if (this.months[item.month - 1] == this.monthLabel[i]) {
            singleval = item.single;
            multival = item.multiple;
          }
        });
        singlecnt.push(singleval);
        multicnt.push(multival);
      }

      this.ABBAData = {
        labels: this.monthLabel,
        datasets: [
          {
            label: 'Single',
            data: singlecnt,
            lineTension: 0,
            fill: false,
            borderColor: '#0083c9',
            backgroundColor: '#0083c9',
          },
          {
            label: 'Multiple',
            data: multicnt,
            lineTension: 0,
            fill: false,
            borderColor: '#c7820a',
            backgroundColor: '#c7820a',
          },
        ],
      };
    });

    this.dashboardSummaryService.getDBABBACust(supplierObj.id).then((jobDetail) => {
      let singlecnt = [];
      let multicnt = [];
      let custname = [];
      let i = 0;
      jobDetail.forEach((item) => {
        custname.push(item.name);
        //custname.push("Cust" + i);
        singlecnt.push(item.single);
        multicnt.push(item.multiple);
        i = i + 1;
      });
      this.CustABBAData = {
        labels: custname,
        datasets: [
          {
            label: 'Single',
            data: singlecnt,
            lineTension: 0,
            fill: false,
            borderColor: '#0083c9',
            backgroundColor: '#0083c9',
          },
          {
            label: 'Multiple',
            data: multicnt,
            lineTension: 0,
            fill: false,
            borderColor: '#c7820a',
            backgroundColor: '#c7820a',
          },
        ],
      };
    });
  }

  getSummaryItem(id): SummaryData {
    return this.summaryDataList.filter((item: any) => item.id === id)[0];
  }

  displaySummaryView() {
    this.showSummaryView = true;
    this.showDetailView = false;
  }

  setdays(i) {
    if (this.SelectDays != i) {
      this.SelectDays = i;
      this.formatData();
    }
  }
}

export class SummaryData {
  id;
  supplier;
  jobCount;
  jobCountArray;
  jobCountCalc;
  areaHome;
  areaHomeArray;
  areaOutside;
  areaOutsideArray;
  earnings;
  earningsArray;
  average;
  averageArray;
  statOntime;
  statOntimeArray;
  statDelay;
  statDelayArray;
  wtwp;
  wtwpArray;
  wtwop;
  wtwopArray;
  wotwp;
  wotwpArray;
  wotwop;
  wotwopArray;
  rate;
  rateArray;
  Single;
  SingleArray;
  Multiple;
  MultipleArray;
  distanceMin;
  distanceMinArray;
  distanceMax;
  distanceMaxArray;
  distanceAvg;
  distanceAvgArray;
  refusedJobCount;
  refusedJobCountArray;
}
